import { FileText, LayoutDashboard, PanelLeftClose, PanelLeftOpen, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SidebarNavItem } from './SidebarNavItem';
import { SidebarFooter } from './SidebarFooter';
import { BrandLogo } from '@/components/common/BrandLogo';
import { Button } from '@/components/ui';
import { ROUTES } from '@/constants';
import { cn } from '@/utils/cn';

const navGroups = [
  {
    label: 'Principal',
    items: [
      { label: 'Dashboard', to: ROUTES.DASHBOARD, icon: LayoutDashboard },
      { label: 'Gerar ata', to: ROUTES.GERAR_ATA, icon: FileText },
    ],
  },
];

export function Sidebar({ collapsed, onToggleCollapse, mobileOpen, onCloseMobile }) {
  return (
    <>
      <div
        className={cn(
          'fixed inset-0 z-40 bg-slate-950/50 lg:hidden',
          mobileOpen ? 'block' : 'hidden',
        )}
        onClick={onCloseMobile}
        aria-hidden
      />

      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-50 flex flex-col bg-[var(--sidebar)] text-[var(--sidebar-foreground)] transition-all duration-200 lg:static',
          collapsed ? 'w-[var(--sidebar-collapsed-width)]' : 'w-[var(--sidebar-width)]',
          mobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
        )}
        aria-label="Navegação principal"
      >
        <div className="flex h-[var(--header-height)] items-center justify-between gap-2 border-b border-white/10 px-3">
          <Link to={ROUTES.DASHBOARD} className="min-w-0 shrink">
            <BrandLogo
              variant={collapsed ? 'icon' : 'horizontal'}
              size={collapsed ? 'sm' : 'md'}
            />
          </Link>
          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="icon"
              className="hidden text-[var(--sidebar-foreground)] hover:bg-[var(--sidebar-muted)] lg:inline-flex"
              onClick={onToggleCollapse}
              aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
            >
              {collapsed ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="text-[var(--sidebar-foreground)] hover:bg-[var(--sidebar-muted)] lg:hidden"
              onClick={onCloseMobile}
              aria-label="Fechar menu"
            >
              <X size={18} />
            </Button>
          </div>
        </div>

        <nav className="flex-1 space-y-4 overflow-y-auto p-3">
          {navGroups.map((group) => (
            <div key={group.label}>
              {!collapsed ? (
                <p className="mb-2 px-2 text-xs font-medium uppercase tracking-wider text-slate-400">
                  {group.label}
                </p>
              ) : null}
              <div className="space-y-1">
                {group.items.map((item) => (
                  <SidebarNavItem
                    key={item.label}
                    item={item}
                    collapsed={collapsed}
                  />
                ))}
              </div>
            </div>
          ))}
        </nav>

        <SidebarFooter collapsed={collapsed} />
      </aside>
    </>
  );
}
